import { capture } from '@/utils/analytics';

export type DiscountCountdownSurface = 'banner' | 'pricing';

// One `discount_countdown_shown` per surface per page load: the banner
// re-mounts on shell route changes and the pricing page on every visit, and
// the event marks that the surface was seen, not how many times it rendered.
const shownSurfaces = new Set<DiscountCountdownSurface>();

export const captureDiscountCountdownShown = (
  surface: DiscountCountdownSurface,
  remainingMs: number
) => {
  if (shownSurfaces.has(surface)) return;
  shownSurfaces.add(surface);

  capture('discount_countdown_shown', {
    surface,
    seconds_remaining: Math.max(0, Math.round(remainingMs / 1000)),
  });
};

export const resetDiscountCountdownShownForTests = () => {
  shownSurfaces.clear();
};
